<template>
    <b-card no-body>
        <b-card-header>
            <span class="h5">SOLICITAÇÃO DE ACESSO</span>
        </b-card-header>
        <b-card-body>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <h5 class="heading-1">
                    <span>PROCESSO</span>
                </h5>
                <app-k-v titulo="Tipo do Acesso" :md="3" :lg="2" :xl="1">
                    <app-status :status="tipoAcessoDescr"></app-status>
                </app-k-v>
                <app-k-v titulo="Status" :md="3" :lg="2" :xl="1">
                    <app-status :status="statusDescr"></app-status>
                </app-k-v>
                <app-k-v
                    titulo="Data da Solicitação"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="dataSolicitacao"
                ></app-k-v>
                <app-k-v
                    titulo="Última Atualização"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="dataAtualizacao"
                    v-if="status == 0"
                ></app-k-v>
                <app-k-v
                    titulo="Aprovado em"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="dataAtualizacao"
                    v-if="status == 1"
                ></app-k-v>
                <app-k-v
                    titulo="Reprovado em"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="dataAtualizacao"
                    v-if="status == 2"
                ></app-k-v>
                <app-k-v
                    titulo="Atualizado por"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="usuarioAtualizacao"
                    v-if="status == 0"
                ></app-k-v>
                <app-k-v
                    titulo="Aprovado por"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="usuarioAtualizacao"
                    v-if="status == 1"
                ></app-k-v>
                <app-k-v
                    titulo="Reprovado por"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="usuarioAtualizacao"
                    v-if="status == 2"
                ></app-k-v>
                <app-k-v
                    titulo="Justificativa"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="justificativa"
                    v-if="status == 2"
                ></app-k-v>
                <div v-if="tipoAcesso == 1">
                    <h5 class="heading-1 mt-4">
                        <span>DADOS DO FORNECEDOR</span>
                    </h5>
                    <app-k-v
                        titulo="CNPJ"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="cpfCnpjFornecedor"
                    ></app-k-v>
                    <app-k-v
                        titulo="Razão Social"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="razaoSocialFornecedor"
                    ></app-k-v>
                    <app-k-v
                        titulo="Email"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="emailFornecedor"
                    ></app-k-v>
                    <app-k-v
                        titulo="Telefone"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="telefone01Fornecedor"
                    ></app-k-v>
                    <app-k-v
                        titulo="Celular"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="telefone02Fornecedor"
                    ></app-k-v>
                    <!-- <app-k-v
                        titulo="Fornecedor do Sebrae"
                        :md="3"
                        :lg="2"
                        :xl="1"
                        :dado="fornecedorSebrae"
                    ></app-k-v> -->
                </div>
                <h5 class="heading-1 mt-4">
                    <span>DADOS DO USUÁRIO</span>
                </h5>
                <app-k-v
                    titulo="CPF"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="cpfUsuario"
                ></app-k-v>
                <app-k-v
                    titulo="Nome"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="nomeUsuario"
                ></app-k-v>
                <app-k-v
                    titulo="Email"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="emailUsuario"
                ></app-k-v>
                <app-k-v
                    titulo="Telefone"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="telefone01Usuario"
                ></app-k-v>
                <app-k-v
                    titulo="Celular"
                    :md="3"
                    :lg="2"
                    :xl="1"
                    :dado="telefone02Usuario"
                ></app-k-v>
            </div>
        </b-card-body>
        <b-card-footer>
            <btn-aprovar
                :solicitacaoAcessoId="solicitacaoAcessoId"
                :cpfCnpjFornecedor="
                    tipoAcesso == 1 ? cpfCnpjFornecedor : cpfUsuario
                "
                :razaoSocialFornecedor="
                    tipoAcesso == 1 ? razaoSocialFornecedor : nomeUsuario
                "
                v-if="
                    status == 0 &&
                        ($temAcessoView('CTRLACS-SOLACS-02') ||
                            $temAcessoView('CTRLACS-SOLACS-03'))
                "
                @obterSolicitacaoAtualizada="obterSolicitacaoAtualizada"
                @atualizarErros="atualizarErros"
            ></btn-aprovar>
            <btn-reprovar
                :solicitacaoAcessoId="solicitacaoAcessoId"
                :cpfCnpjFornecedor="
                    tipoAcesso == 1 ? cpfCnpjFornecedor : cpfUsuario
                "
                :razaoSocialFornecedor="
                    tipoAcesso == 1 ? razaoSocialFornecedor : nomeUsuario
                "
                v-if="
                    status == 0 &&
                        ($temAcessoView('CTRLACS-SOLACS-02') ||
                            $temAcessoView('CTRLACS-SOLACS-03'))
                "
                @obterSolicitacaoAtualizada="obterSolicitacaoAtualizada"
                @atualizarErros="atualizarErros"
            ></btn-reprovar>
            <b-button variant="danger" @click.stop="voltar()" class="mr-2">
                <span> <i class="fa fa-history"></i> Voltar </span>
            </b-button>
        </b-card-footer>
    </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import SolicitacoesAcessoServicos from './SolicitacoesAcessoServicos'
import BtnReprovar from './BtnReprovar'
import BtnAprovar from './BtnAprovar'

export default {
    components: {
        BtnReprovar,
        BtnAprovar
    },

    data() {
        return {
            erros: [],
            solicitacaoAcessoId: '',
            dataSolicitacao: '',
            cpfCnpjFornecedor: '',
            razaoSocialFornecedor: '',
            emailFornecedor: '',
            telefone01Fornecedor: '',
            telefone02Fornecedor: '',
            cpfUsuario: '',
            nomeUsuario: '',
            emailUsuario: '',
            telefone01Usuario: '',
            telefone02Usuario: '',
            statusDescr: '',
            dataAtualizacao: '',
            usuarioAtualizacao: '',
            status: '',
            justificativa: '',
            tipoAcesso: '',
            tipoAcessoDescr: '',
            fornecedorSebrae: ''
        }
    },
    methods: {
        atualizarErros(erros) {
            this.erros = erros
        },

        voltar() {
            this.erros = []
            this.$router.push({ name: 'SolicitacoesAcesso' })
        },

        obterSolicitacaoAcesso() {
            this.$store.dispatch('addRequest')
            SolicitacoesAcessoServicos.obterPorId(
                this.$route.params.solicitacaoAcessoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.preencheFormulario(response.data)
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterSolicitacaoAtualizada() {
            this.obterSolicitacaoAcesso()
            this.$store.dispatch('setRecarregar', true)
        },

        preencheFormulario(data) {
            this.solicitacaoAcessoId = data.solicitacaoAcessoId
            this.dataSolicitacao = this.$maskDate(data.dataSolicitacao)
            this.dataAtualizacao = this.$maskDateTime(data.dataAtualizacao)
            this.cpfCnpjFornecedor = this.$maskCpfCnpj(data.cpfCnpjFornecedor)
            this.razaoSocialFornecedor = data.razaoSocialFornecedor
            this.emailFornecedor = data.emailFornecedor
            this.telefone01Fornecedor = this.$maskTelefone(
                data.telefone01Fornecedor
            )
            this.telefone02Fornecedor = this.$maskTelefone(
                data.telefone02Fornecedor
            )
            this.cpfUsuario = this.$maskCpfCnpj(data.cpfUsuario)
            this.nomeUsuario = data.nomeUsuario
            this.emailUsuario = data.emailUsuario
            this.telefone01Usuario = this.$maskTelefone(data.telefone01Usuario)
            this.telefone02Usuario = this.$maskTelefone(data.telefone02Usuario)
            this.usuarioAtualizacao = data.usuarioAtualizacao
            this.status = data.status
            this.statusDescr = data.statusDescr
            this.justificativa = data.justificativa
            this.tipoAcesso = data.tipoAcesso
            this.tipoAcessoDescr = data.tipoAcessoDescr
            this.fornecedorSebrae = data.fornecedorSebrae ? 'SIM' : 'NÃO'
        }
    },

    created() {
        this.obterSolicitacaoAcesso()
    }
}
</script>
